import React from 'react';
import _ from 'lodash';
import App from '../../containers/App'
import { useDebug } from '../../hooks';
 
import {
  appData,
  demoData,
  Container,
  Content, 
  GlobalStyles,  
  StyleSheets,
  Header, 
  HeaderRow, 
  DemoContent,
  DemoLogo, 
} from '../demo-utils'

const AppDemo = () => {
  useDebug(`AppDemo`)

  if ( _.isEmpty( {...appData} ) ) return null;
  
  return (<> 
    <StyleSheets url={demoData.config.stylesheetURL} />
    <GlobalStyles fontFamily={demoData.config.fontFamily} />
    <Header>
      <HeaderRow {...demoData.theme.header}>
        <Container style={{color: 'white'}}>
          <DemoLogo> 
            {demoData.config.logo}
          </DemoLogo>
          <App />
        </Container>
      </HeaderRow>
    </Header>
    <Content>
      <Container>
        <DemoContent />
      </Container>
    </Content>
  </>)
}

export default AppDemo
